<template>
  <div id="Bridge">
    <bg-video ref="bv" :class="{ blur }" :filename="filename" autoplay loop/>
    <logo/>
    <guide-button class="btn-lt" @click.native="next(step - 1)">返回</guide-button>
    <guide-button class="btn-rt" @click.native="handleNarrateEnded">继续</guide-button>
  </div>
</template>

<script>
import logo from '../Logo'
export default {
  name: 'Bridge',
  components: {
    logo,
  },
  data () {
    return {
      blur: false,
      step: this.$route.query.step || 0,
      fnList: [
        () => this.playNarrate('12', { btnText: '港珠澳大桥桥墩安装' }).then(_ => this.$vplayer.play({ url: 'qdaz' })).then(() => this.next(this.step + 1)),
        () => this.playNarrate('12-2', { btnText: '钢箱梁桥面吊装' }).then(_ => this.$vplayer.play({ url: 'gtdq' })).then(() => this.next(this.step + 1)),
        () => this.playNarrate('13', { btnText: '海豚塔翻身吊装' }).then(_ => this.$vplayer.play({ url: 'fsdz' })).then(() => this.next(this.step + 1)),
        () => this.playNarrate('14', { btnText: '世界最大单体钢桥面铺装' }).then(_ => this.$vplayer.play({ url: 'qmpz' })).then(() => this.next(this.step + 1)),
        () => this.playNarrate('15', { btnText: '主体工程全线亮灯' }).then(_ => this.$vplayer.play({ url: 'qxld' })).then(() => this.$router.push('/TitlePage/02')),
      ],
    }
  },
  computed: {
    filename () {
      if (this.step === 2 || this.step === 3) {
        return `Bridge-${this.step - 1}`
      }
      return 'Bridge-0'
    },
  },
  mounted () {
    this.next(this.step)
  },
  methods: {
    next (step) {
      this.$vplayer.clear()
      if (step < 0) {
        this.$router.push('/Part01/Tunnel')
      }
      this.blur = false
      this.$refs.bv.play()
      this.step = step
      this.fnList[step]()
    },
    playNarrate (filename, opts) {
      this.blur = false
      this.$refs.bv.play()
      return this.$narrate.play(filename, { ...opts, onended: this.handleNarrateEnded })
    },
    handleNarrateEnded () {
      this.$narrate.skip()
      this.$refs.bv.pause()
      this.blur = true
    },
  },
}
</script>
